const getSubdomain = () => {
  var isApp = window.location.hostname.includes("app");
  var absoluteUrl = window.location.hostname; //withoutPath && withoutProtocol
  var relativeURL = window.location.href.split('?')[0].replace(/^(https?:)?\/\//, ''); //withPath && withoutProtocol && withoutParams
  if (isApp) {
    return relativeURL;
  } else {
    return absoluteUrl;
  }
};

const getAppName = (app = "") => {
  const aiApp = app ? app : getSubdomain();
  if (aiApp.includes("chatpdf")) {
      return "ChatPDF";
  } else if (aiApp.includes("storybook")) {
      return "Storybook";
  } else if (aiApp.includes("teacher")) {
      return "Teacher AI";
  } else if (aiApp.includes("chatgpt")) {
      return "ChatGPT";
  } else if (aiApp.includes("chatpro")) {
      return "ChatGPTPro";
  } else if (aiApp.includes("interior")) {
      return "Interior AI";
  } else if (aiApp.includes("restorephotos")) {
      return "Restore Photo";
  } else if (aiApp.includes("removebg")) {
      return "Remove Background";
  } else if (aiApp.includes("avatarmaker")) {
      return "Avatar Maker";
  } else if (window.location.href.includes("translate")) {
      return "TranslateNow";
  } else if (window.location.href.includes("recipe")) {
      return "Recipe Maker";
  } else if (window.location.href.includes("travel")) {
      return "Trips AI";
  } else if (aiApp.includes("chatlibrary")) {
      return "ChatLibrary";
  } else if (aiApp.includes("chat")) {
      return "ChatGPT";
  } else if (aiApp.includes("multillm")) {
      return "Multi-Chat";
  } else if (aiApp.includes("search")) {
      return "Search AI";
  } else if (window.location.href.includes("convert-to-proper-english")) {
      return "Grammar AI";
  } else if (window.location.href.includes("dream-photo")) {
      return "DreamPhoto";
  } else if (window.location.href.includes("coding")) {
    	return "Coding AI";
	} else if (window.location.href.includes("flux")) {
		return "Flux ImageGen";
	} else if (window.location.href.includes("tutor")) {
		return "Homework Help";
	}

  return "the app";
}

module.exports = { getAppName, getSubdomain };